import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-seller-details-event-data',
  templateUrl: './seller-details-event-data.component.html',
  styleUrls: ['./seller-details-event-data.component.scss'],
})
export class SellerDetailsEventDataComponent {
  @Input() seller_id?: string | null;
  is_read_running = true;

  ngOnInit(): void {
    this.listSellerEvent(this.seller_id as string);
  }

  onRefresh(): void {
    this.listSellerEvent(this.seller_id as string);
  }

  listSellerEvent(seller_id?: string): void {
    this.is_read_running = true;

    if (seller_id) {
      this.is_read_running = false;
    }
  }
}
